import { AppRoute, ConfigSettingsService, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class AntragListNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.SIGNED_IN;

  constructor(private readonly config: ConfigSettingsService) {
    super('ANTRAG_LIST', _('menu.label.antrag_uebersicht'), AppRoute.AntragOverview, _('a11y.link.antrags_uebersicht'));
  }

  public guard(): boolean {
    return this.config.appSettings.customizing.hasUebersicht;
  }
}
